module.exports = __webpack_public_path__ + "images/enepi/oiwaikin_campaign_banner_6d7684450aa218646cc82e6232e94d1e.png";